const pagesAccessesEn = {
  filter: {
    date: 'Date',
    device: 'Device',
    export: {
      disabledTab: 'Export is available only on the Registered Software or All tab.'
    },
    id: 'ID',
    people: 'People',
    placeholder: 'Filter...',
    software: 'Software'
  },
  help: {
    shadowAI: {
      text: 'These are access logs to generative AI services that are not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
      title: 'Shadow AI?'
    },
    shadowID: {
      text: 'These are access logs for try login to ID that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
      title: 'Shadow Identity?'
    },
    shadowIt: {
      text: 'These are access logs to software that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
      title: 'Shadow IT?'
    }
  },
  // Overview画面
  overview: {
    accesses: 'Accesses',
    appUnit: 'items',
    blocked: 'Blocked',
    detectedApps: 'Detected software',
    registered: 'Registered',
    tolerated: 'Tolerated',
    unregistered: 'Unregistered',
    bento: {
      accessUnit: 'services',
      comingSoon: 'Coming soon',
      dormancy: {
        accountUnit: 'accounts',
        affectedSoftware: 'Affected software',
        estimatedSaving: 'Est. monthly saving',
        estimatedSavingNote: 'Calculated via Contract & Cost',
        monthOverMonth: 'MoM',
        threshold: 'Threshold',
        title: 'Dormant candidates'
      },
      governanceScore: {
        breakdownTitle: 'Score breakdown',
        comingSoonNote: 'Available once risk scoring and tolerate/block policies are implemented.',
        factorClassification: 'Classification coverage',
        factorDormancy: 'Dormancy response',
        factorPermission: 'Permission & MFA',
        factorShadow: 'Shadow response',
        grade: 'B · Room for improvement',
        title: 'Scoring',
        topImprovementTitle: 'Top improvement'
      },
      memberUnit: '',
      monthlyUsage: {
        accessCount: 'Access count',
        measuredNote: 'Measured via browser extension & audit-log integrations',
        memberCount: 'Active members',
        monthOverMonth: 'Access count trend',
        title: "This month's usage"
      },
      newlyDetected: {
        title: 'Most-accessed software',
        userUnit: 'users'
      },
      seeMore: 'See more',
      shadowDetection: {
        help: 'The number of shadow IT / ID / AI newly detected this month (first detected this month). Re-access to already-detected services is not counted.',
        title: 'Shadow detection',
        unit: 'this month'
      },
      shadowTrend: {
        help: 'Compares the number newly detected in the previous and current month (first detected in each month). Re-access to already-detected services is not counted.',
        prevMonthLabel: 'Last month',
        subtitle: 'Prev → this month, by type',
        thisMonthLabel: 'This month',
        title: 'Shadow detection trend'
      }
    }
  },
  // 一覧画面
  nav: {
    alerts: 'Alerts',
    contractAndCost: 'Contract & Cost',
    logs: 'Logs',
    overview: 'Overview',
    settings: 'Settings',
    software: 'Software'
  },
  productHeader: {
    pageTitle: 'Accesses'
  },
  identity: {
    detectedEmail: 'Detected email',
    detectedWorkerNumber: 'Detected worker number'
  },
  table: {
    accessedTo: 'Accessed to',
    action: 'Action',
    device: 'Device',
    id: 'ID',
    timestamp: 'Timestamp',
    visit: 'Visit',
    whoAccessed: 'Who accessed'
  },
  tabs: {
    all: 'All',
    blocked: 'Blocked IT Services',
    registered: 'Registered Software',
    tolerated: 'Tolerated IT Services'
  },
  // アラート画面
  alerts: {
    filter: {
      category: 'Category',
      itService: 'IT Service',
      member: 'Member',
      placeholder: 'Filter...'
    },
    loadError: 'Failed to load data. Please try again later.',
    sideTabs: {
      closeSideTab: 'Close side tab',
      dormantAI: 'Dormant AI',
      dormantID: 'Dormant ID',
      dormantIT: 'Dormant IT',
      shadowAI: 'Shadow AI',
      shadowID: 'Shadow Identity',
      shadowIT: 'Shadow IT'
    },
    summary: {
      fromLastMonth: 'from last month',
      help: {
        totalAccessCount: 'The total number of accesses collected this month from browsers with the browser extension installed.',
        uniqueMemberCount: 'The number of unique users who accessed from browsers with the browser extension installed this month.',
        uniqueShadowAI: 'The total number of shadow AI services detected from the past up to this month.',
        uniqueShadowID: 'The total number of shadow identities detected from the past up to this month.',
        uniqueShadowIT: 'The total number of shadow IT services detected from the past up to this month.'
      },
      totalAccessCount: 'Monthly unique accesses',
      uniqueMemberCount: 'Monthly accessed people',
      uniqueShadowAI: 'Detected Shadow AI',
      uniqueShadowID: 'Detected Shadow Identity',
      uniqueShadowIT: 'Detected Shadow IT'
    },
    table: {
      access7Days: '7-day total access count',
      access30Days: '30-day total access count',
      category: 'Category',
      itService: 'IT Service',
      members: 'Members',
      uniqueUserCount: 'Unique user count'
    },
    unknownUser: 'Unknown user'
  },
  list: {
    backToList: 'Back to list'
  },
  alertDetail: {
    breadcrumb: 'Accesses',
    filter: {
      placeholder: 'Filter...'
    },
    pageTitle: 'Alert Detail'
  },
  dormancy: {
    filter: {
      placeholder: 'Filter...'
    },
    help: {
      text: 'Accounts with no login or access within the configured period (counting back from the current month) are detected as dormant candidates.<br />Detection uses whichever is more recent: the last login or the last access. Accesses are detected from visit history collected by the browser extension.<br />Example: As of April 13<br />・1 month → Before March 1 (= no login or access in March or April)<br />・2 months → Before February 1 (= no login or access in February, March, or April)',
      title: 'How dormancy detection works'
    },
    summary: {
      affectedSoftwareCount: 'Affected Software',
      connectedSaaS: 'Connected SaaS',
      customSetting: 'Custom Setting',
      defaultSetting: 'Default Setting',
      dormantAccountCount: 'Dormant Candidates',
      fromLastMonth: 'from last month',
      help: {
        affectedSoftwareCount: 'Number of software with dormant candidates detected.',
        dormantAccountCount: 'Total number of dormant candidates detected across all connected software.',
        dormantRate: 'Percentage of dormant candidates. Excluded and suspend candidate accounts are not included.',
        threshold: 'Accounts with no login or access by the beginning of the target month are detected as dormant candidates, based on whichever is more recent: the last login or the last access.'
      },
      monthUnit: 'months',
      threshold: 'Detection Criteria'
    }
  },
  dormancyAi: {
    help: {
      text: 'Generative AI services with no access within the configured period (counting back from the current month) are detected as dormant candidates.<br />Example: As of April 13<br />・1 month → Before March 1 (= no access in March or April)<br />・2 months → Before February 1 (= no access in February, March, or April)'
    },
    summary: {
      connectedSaaS: 'Detected generative AI services',
      help: {
        dormantAccountCount: 'Total number of dormant candidates detected across all detected generative AI services.',
        threshold: 'Accounts with no access by the beginning of the target month are detected as dormant candidates.'
      }
    }
  },
  dormancyDetail: {
    bulkAction: {
      bulkExclude: 'Bulk exclude selected',
      bulkRemoveExclude: 'Remove exclusion',
      bulkSuspend: 'Bulk suspend selected',
      bulkUnsuspend: 'Unsuspend selected',
      selectedCount: '{{count}} selected'
    },
    cellState: {
      noRecord: 'No record',
      notMeasurable: 'Not measurable'
    },
    dormantDays: '{{count}} days',
    filter: {
      dormantDays: 'Dormant days',
      dormantDaysRange: '{{min}}-{{max}} days',
      dormantDaysRangeOpen: '{{min}}+ days',
      pattern: 'Pattern'
    },
    pattern: {
      alumni: 'Alumni',
      invited: 'Invited',
      lowFrequency: 'Low frequency',
      onLeave: 'On leave',
      unused: 'Unused'
    },
    provenance: {
      api: 'API',
      auditLog: 'Audit log',
      browserExtension: 'Browser extension',
      manualCsv: 'Manual CSV'
    },
    rowAction: {
      excludeFlag: 'Exclude',
      removeExclude: 'Remove exclusion',
      suspendBlockedTooltip: 'Cannot suspend: recent activity detected',
      suspendFlag: 'Suspend candidate',
      unsuspend: 'Unsuspend'
    },
    tab: {
      alert: 'Review',
      excluded: 'Excluded',
      suspendCandidate: 'Suspend candidate'
    },
    toast: {
      excludeSuccess: 'Exclusion flag set',
      removeSuccess: 'Exclusion removed',
      suspendSuccess: 'Marked as suspend candidate'
    }
  },
  dormancySettings: {
    description: 'Detection is based on whichever is more recent: the last login or the last access of active accounts. Accesses are detected via the browser extension. Suspended accounts are always excluded.',
    excludeInvitedAccounts: 'Exclude Invited Accounts',
    excludeInvitedAccountsDescription: 'When ON, invited accounts that have not yet started usage will be excluded from dormancy detection.',
    lastLoginThreshold: 'Dormancy Detection Criteria',
    lastLoginThresholdDescription: 'Accounts with no login or access by the beginning of the target month are detected as dormant candidates.',
    loadError: 'Failed to load settings. Please try again later.',
    oneMonth: '1 Month',
    pageTitle: 'Settings',
    save: 'Save Settings',
    saveSuccess: 'Settings saved successfully',
    sectionTitle: 'Dormant IT Detection Settings',
    toggleOff: 'OFF',
    toggleOn: 'ON',
    twoMonths: '2 Months'
  },
  gwsAuditLogSettings: {
    columns: {
      actions: '',
      appIntegration: 'Integration',
      enabled: 'Enabled',
      status: 'Status'
    },
    description: 'Collect audit logs from Google Workspace and display them on the access log screen.',
    disable: {
      confirmDescription: 'Audit log collection will stop. Existing collected logs will remain.',
      confirmOk: 'Disable',
      confirmTitle: 'Disable Google Workspace audit log integration?'
    },
    enable: {
      confirmDescription: 'You will be redirected to the Google consent screen to grant audit log read permission. Please sign in with a Google Workspace administrator account.',
      confirmOk: 'Connect',
      confirmTitle: 'Enable Google Workspace audit log integration?'
    },
    expandButton: {
      collapse: 'Hide details',
      expand: 'Show details'
    },
    notInstalled: {
      linkLabel: 'Go to integration settings',
      message: 'Please connect Google Workspace first.'
    },
    sectionTitle: 'Google Workspace Audit Log Integration',
    status: {
      connected: 'Connected',
      disabled: 'Disabled',
      needsReauth: 'Insufficient permission'
    },
    tenantCount_one: '{{count}} tenant',
    tenantCount_other: '{{count}} tenants',
    toast: {
      disableSuccess: 'Disabled successfully'
    },
    toggle: {
      off: 'OFF',
      on: 'ON'
    },
    warning: {
      missingScope: 'Additional permission is required. Please re-authenticate.',
      reauthButton: 'Reconnect'
    }
  },
  settings: {
    pageTitle: 'Settings'
  },
  pagination: {
    of: 'of',
    page: 'Page',
    rows: 'rows',
    rowsPerPage: 'Rows per page'
  }
};
export default pagesAccessesEn;